export const ACCESS_TOKEN = 'accessToken';
export const TOKEN = 'token';
export const ID_TOKEN = 'idToken';
export const MAX_SESSION_AGE = 43200;

export const UNIFIED_LOGIN_LOG_IN = 'login';
export const UNIFIED_LOGIN_LOG_OUT = 'logout';
export const UNIFIED_LOGIN_LEARN_MORE = 'learn_more';
export const UNIFIED_LOGIN_PROFILE = 'profile';
